import React from 'react'
import { Col } from 'react-bootstrap'

import Checkbox from '../../../../../../Checkbox'
import Field from '../../../../../../Field'
import { IFilterType } from '../../../../../types'

const CheckboxType = (props: IFilterType): React.ReactElement => {
  const { filter = {}, index } = props
  return (
    <Col md={filter.colWidth ? filter.colWidth : 6} key={index}>
      <Field name={filter.name as string}>
        <Checkbox label={`${filter.label}`} />
      </Field>
    </Col>
  )
}

export default CheckboxType
